import { cva } from 'class-variance-authority'

export const toggleVariants = cva(
  'inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground',
  {
    variants: {
      variant: { default: 'bg-transparent', outline: 'border bg-transparent' },
      size: { default: 'h-9 px-3', sm: 'h-8 px-2', lg: 'h-10 px-4' },
    },
    defaultVariants: { variant: 'default', size: 'default' },
  },
)
